import script from "./e-card.vue?vue&type=script&setup=true&lang=js"
export * from "./e-card.vue?vue&type=script&setup=true&lang=js"

import "./e-card.vue?vue&type=style&index=0&id=2031abdf&lang=scss&scoped=true"

import exportComponent from "D:\\code\\sns\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2031abdf"]])

export default __exports__